"use client";
import { motion } from "framer-motion";
import { Card, CardContent } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";

const specifications = [
  { label: "Coverage", value: "50-65 sq ft per gallon" },
  { label: "Thickness", value: "2-3mm when applied" },
  { label: "Dry Time", value: "24-48 hours" },
  { label: "Finish Options", value: "Matte, Satin, Semi-Gloss" },
  { label: "Colors Available", value: "12 standard colors" },
  { label: "Suitable For", value: "Floors, walls, countertops" },
];

export function ConcrettaSpecifications() {
  return (
    <section
      id="concretta-specifications"
      className="py-24 bg-foreground/5 dark:bg-card/30 transition-colors"
      data-header-scheme="light"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            <h2 className="font-serif text-3xl md:text-4xl font-light text-foreground mb-6 tracking-tight">
              Technical Specifications
            </h2>
            <Card className="border-border bg-card shadow-lg">
              <CardContent className="p-8">
                <div className="space-y-4">
                  {specifications.map((spec, index) => (
                    <div key={spec.label}>
                      <div className="flex justify-between items-center py-3">
                        <span className="font-medium text-foreground">
                          {spec.label}
                        </span>
                        <span className="text-muted-foreground">
                          {spec.value}
                        </span>
                      </div>
                      {index < specifications.length - 1 && <Separator />}
                    </div>
                  ))}
                </div>
              </CardContent>
            </Card>
          </motion.div>
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            <h2 className="font-serif text-3xl md:text-4xl font-light text-foreground mb-6 tracking-tight">
              Application Guide
            </h2>
            <div className="space-y-6">
              {[
                {
                  title: "Preparation",
                  text: "Clean and prepare the surface. Prime if necessary for optimal adhesion.",
                },
                {
                  title: "Application",
                  text: "Apply in thin, even coats using a steel trowel. Allow each coat to dry completely.",
                },
                {
                  title: "Finishing",
                  text: "Sand lightly between coats and seal with recommended topcoat for durability.",
                },
              ].map((step) => (
                <Card
                  key={step.title}
                  className="border-border bg-card shadow-lg"
                >
                  <CardContent className="p-6">
                    <h3 className="font-serif text-lg font-medium text-foreground mb-3 tracking-tight">
                      {step.title}
                    </h3>
                    <p className="text-muted-foreground mb-4">{step.text}</p>
                  </CardContent>
                </Card>
              ))}
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
